<template>
  <div v-show="isVisible" class="dialog-wrapper layout justify-center align-center">
    <v-scale-transition>
      <div v-show="isMounted" :style="size" class="form-wrapper column  px-4 py-3 elevation-10">
        <div class="header mb-4 layout no-wrap align-center">
          <div class="header">
            {{ title || 'Manage Content' }}
          </div>
          <v-spacer />
          <v-btn icon small @click.stop="$emit('close')">
            <v-icon>{{ icons.close }}</v-icon>
          </v-btn>
          <slot name="header-action" />
        </div>
        <div class="form-container">
          <v-fade-transition v-if="baseForms && !notViaRouter">
            <component :is="baseForms" />
          </v-fade-transition>
          <slot name="form" />
        </div>
        <div
          v-if="widthPagination || $route.query.stepper"
          class="pagination-container mt-4 layout align-center justify-center"
        >
          <pagination :steps="JSON.parse($route.query.steps)" :current-step="JSON.parse($route.query.step)" />
        </div>
      </div>
    </v-scale-transition>
  </div>
</template>

<script>
import { FORMS } from '@/config/constants';
import paginationVue from '../../pagination/pagination.vue';
import icons from '@/mixins/icons';
export default {
  name: 'BaseDialog',
  components: {
    pagination: paginationVue
  },
  mixins: [icons],
  props: {
    width: String,
    height: String,
    formComponent: {
      type: Function
    },
    closable: Boolean,
    notViaRouter: Boolean,
    label: {
      type: String,
      default: null
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    widthPagination: {
      type: Boolean
    }
  },
  data() {
    return {
      isMounted: false
    };
  },
  computed: {
    size() {
      let size = {};
      if (this.width || this.height) {
        if (this.width) {
          size['minWidth'] = `${this.width}`;
          size['maxWidth'] = `${this.width}`;
        }

        if (this.height) {
          size['minHeight'] = `${this.height}`;
          size['maxHeight'] = `${this.height}`;
        }
      }
      return size;
    },
    baseForms() {
      const form = FORMS.get(this.$route.query.form);
      if (form || this.formComponent) {
        return this.formComponent || form.component || null;
      }
    },
    title() {
      const form = FORMS.get(this.$route.query.form);

      return this.label || form.title;
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style scoped>
.dialog-wrapper {
  position: fixed;
  z-index: 10000;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
}
.form-wrapper {
  background-color: white !important;
  min-width: 440px;
  border-radius: 2px;
  max-width: 700px;
}
.header {
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  max-height: 35px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}
.form-wrapper {
  display: inline-flex;
  flex-direction: column;
}
.form-container {
  height: 100%;
  flex-grow: 1;
  position: relative;
}
</style>
